import withIcon from './NewIcon';
// @ts-ignore
import IconFacebook from './icon/l/facebook.s.svg';

export default withIcon(IconFacebook);
